package hk.com.vr360_demo2.webapp.component

import react.*
import mui.material.Snackbar
import mui.material.Alert

val ToastContext: Context<(msg: String, severity: String) -> Unit> =
    createContext({ _: String, _: String -> })

val ToastProvider = FC<PropsWithChildren> { props ->
    val (open, setOpen) = useState(false)
    val (msg, setMsg) = useState("")
    val (severity, setSeverity) = useState("success")

    val showToast = { message: String, sev: String ->
        setMsg(message)
        setSeverity(sev)
        setOpen(true)
    }
   
    ToastContext.Provider {
        value = showToast
        +props.children
        Snackbar {
            this.open = open
            autoHideDuration = 2000
            asDynamic().anchorOrigin = js("{ vertical: 'top', horizontal: 'center' }")
            onClose = { _, _ -> setOpen(false) }
            Alert {
                this.severity = severity
                +msg
            }
        }
    }
}

fun useToast(): (msg: String, severity: String) -> Unit {
    val react = js("require('react')")
    return react.useContext(ToastContext) as (String, String) -> Unit
}

